import { computed, get } from '@ember/object';

export default function notEqual(dependentKey, targetValue) {
  return computed(dependentKey, function () {
    return get(this, dependentKey) !== targetValue;
  });
}
